import React, { useContext, useState } from 'react';
import { View, Dimensions } from 'react-native';
import { useColorScheme } from 'react-native-appearance';
import { colors } from '../context/Colors';
import AppContext from '../context';
import GameFooter from './GameFooter';
import GameDescription from './GameDescription';
import { TextInput } from 'dripsy';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

export default function Question({ g, current }) {
  const theme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const { tour, setTour, dict } = useContext(AppContext);
  const [textInputY, setTextInputY] = useState(0);

  const setText = (t) => {
    g.answer = t; //.trim();
    if (t !== '') g.state = 'can-answer';
    else g.state = '';
    setTour({ ...tour });
  };

  const render = () => (
    <View>
      <GameDescription g={g} current={current} />

      <TextInput
        style={{
          borderBottomColor: colors[theme].pin,
          borderBottomWidth: 2,
          paddingVertical: 5,
          marginTop: 30,
          fontSize: 20,
          color: colors[theme].text
        }}
        sx={{ width: ['100%', '50%'] }}
        placeholder={dict.type_here}
        onChangeText={(e) => setText(e)}
        value={g.answer || ''}
        editable={g.state !== 'failed' && g.state !== 'correct'}
        onLayout={(e) => {
          setTextInputY(e.nativeEvent.layout.y);
        }}
      />
      <GameFooter g={g} />
      <View style={{ height: 60 }} />
    </View>
  );

  if (textInputY + 200 > Dimensions.get('screen').height / 2)
    return (
      <KeyboardAwareScrollView extraHeight={150}>
        {render()}
      </KeyboardAwareScrollView>
    );
  else return render();
}
